import { Box, useMediaQueryContext } from "@drone-js/core";
import type { FunctionComponent } from "react";
import { LottiePlayer } from "./LottiePlayer";

export const HeroImage: FunctionComponent = () => {
    const mediaQuery = useMediaQueryContext();

    function getScreenSize() {
        if (mediaQuery.xl) return "xl";
        if (mediaQuery.l) return "l";
        if (mediaQuery.m) return "m";

        return "s";
    }

    return (
        <Box zIndex={1} width="100%" bottom={0} overflow="visible">
            <LottiePlayer
                path={`https://cdn0.agoda.net/images/agoda-homes/partner-marketing/hero-section/hero-section-lottie/${getScreenSize()}.json`}
                containerProps={{
                    width: "100%",
                }}
            />
        </Box>
    );
};
